/* ANGE (Oct 2026): the size a customer picks is ALWAYS the size that goes in the cart.
   Why: on some products the theme's variant script stopped part-way after a size tap, so the
   hidden variant field kept the first available size (often S). The size box looked picked,
   but Add to cart, the sticky bar and Apple Pay all bought the old size.
   Fix: (1) whenever a size/option changes, the chosen variant is worked out straight from the
   option selects and written into the form's hidden variant field; (2) right before adding to
   cart it is worked out again, so a stale value can never be sent. */
function angeResolveVariantId(scope) {
  if (!scope) return null;
  var picker = scope.querySelector('variant-selects, variant-radios');
  if (!picker) return null;
  var json = picker.querySelector('script[type="application/json"]');
  if (!json) return null;
  var selected;
  var selects = picker.querySelectorAll('select');
  if (selects.length) {
    selected = Array.from(selects, function (s) { return s.value; });
  } else {
    selected = Array.from(picker.querySelectorAll('fieldset'), function (fs) {
      var r = fs.querySelector('input:checked');
      return r ? r.value : null;
    });
  }
  var variants;
  try { variants = JSON.parse(json.textContent); } catch (e) { return null; }
  var match = variants.find(function (v) {
    return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
  });
  return match ? match.id : null;
}

function angeScopeOf(el) {
  return (
    el.closest('section[id^="MainProduct-"]') ||
    el.closest('quick-add-modal') ||
    el.closest('product-info') ||
    el.closest('section')
  );
}

document.addEventListener('change', function (e) {
  var picker = e.target && e.target.closest && e.target.closest('variant-selects, variant-radios');
  if (!picker) return;
  var scope = angeScopeOf(picker);
  var id = angeResolveVariantId(scope);
  if (!id || !scope) return;
  scope.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"], form[id^="product-form-installment"] input[name="id"]').forEach(function (input) {
    if (String(input.value) !== String(id)) input.value = id;
  });
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // ANGE: re-check the picked size right before adding (see note at the top).
        try {
          var pickedId = angeResolveVariantId(angeScopeOf(this));
          var idInput = this.form.querySelector('[name=id]');
          if (pickedId && idInput) idInput.value = pickedId;
        } catch (e) {
          console.error(e);
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
